// extracted by css-extract-rspack-plugin
export default {"container":"scroll-view__container___TF3BW"};